import { iso, z } from "zod";
import { uuidSchema } from "./common";

/** Opaque cursor: base64url(JSON.stringify({ createdAt, id })). */
export const cursorPayloadSchema = z.object({
  createdAt: iso.datetime({ offset: true }),
  id: uuidSchema,
});

export type CursorPayload = z.infer<typeof cursorPayloadSchema>;
